import React from 'react';
import { cn } from '../../lib/utils';

const Section = ({ 
  children, 
  className, 
  bg = 'white',
  id
}) => {
  const bgColors = {
    white: 'bg-white',
    surface: 'bg-surface',
    primary: 'bg-primary text-white',
    dark: 'bg-gray-900 text-white',
  };

  return (
    <section id={id} className={cn('py-16 md:py-24', bgColors[bg], className)}>
      <div className="container mx-auto px-4 md:px-6">
        {children}
      </div>
    </section>
  );
};

export default Section;